import React from 'react';
import manufacturingCapacityImage from '../../assets/images/manufacturing_capacity.jpg';

export default function ManufacturingCapacity() {
  return (
    <section className="pb-4 md:pb-[40px] bg-[#F9F9F9]">
      <div className="container-custom">
      <div className="flex flex-col lg:flex-col items-center gap-8">
        {/* Image */}
        {/* <div className="w-full">
            <div
            className="relative w-full h-full md:mx-0 max-w-[347px] max-h-[236px] rounded-[28px] overflow-hidden shadow-lg md:max-w-full md:max-h-full "
            >
            <img
                src={manufacturingCapacityImage}
                alt="Agastya Manufacturing Facility in Ahmedabad"
                className="w-full h-full object-cover"
            />
            </div>
        </div> */}

        <div className="w-full flex justify-center">
        <div className="
          relative w-full max-w-[348px] aspect-[348/236] 
          md:w-[1279px] md:h-[486px] md:max-w-none
          rounded-[28.42px] overflow-hidden shadow-lg
        ">
          <img
            src={manufacturingCapacityImage}
            alt="Agastya Manufacturing Facility in Ahmedabad"
            className="w-full h-full object-cover"
          />
        </div>

        </div>

          
          {/* Content */}
          <div className="w-full ">
            <h2 
              className="text-[20px] md:text-[28px] font-bold leading-[130%] tracking-[-0.03em] text-gray-900 mb-4 inter-font-bold"
            >
              Agastya Agro State-of-the-Art Facility in Ahmedabad
            </h2>
            <p 
              className="text-[12px] md:text-[18px] leading-[150%] text-gray-700 inter-font opacity-50 mb-[13px]"
            >
              Located in the industrial heart of Ahmedabad, Gujarat, our manufacturing facility is a key pillar of Agastya Agro Limited's operations. With cutting-edge equipment and strict quality protocols, this plant enables us to produce a comprehensive range of fungicides, insecticides, and herbicides. Our Ahmedabad unit is built for efficiency, scalability, and compliance—ensuring that we meet the ever-growing demand for high-quality agro solutions across India.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
